import { render, staticRenderFns } from "./newsCategory.vue?vue&type=template&id=5bc6af60&scoped=true&"
import script from "./newsCategory.vue?vue&type=script&lang=js&"
export * from "./newsCategory.vue?vue&type=script&lang=js&"
import style0 from "./newsCategory.vue?vue&type=style&index=0&id=5bc6af60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6af60",
  null
  
)

export default component.exports